import { Button, Grid, Modal, Typography } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

export type SignActType = {
  open: (actNumber: string) => void;
  close: () => void;
};

export const SignActModal = forwardRef<SignActType>((_, ref) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const [actNumber, setActNumber] = useState("");

  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs === true;

  const open = (actNumber: string) => {
    setActNumber(actNumber);
    setOpened(true);
  };

  const close = () => {
    setOpened(false);
  };

  useImperativeHandle(ref, () => ({
    open: (actNumber: string) => open(actNumber),
    close: () => close(),
  }));

  return (
    <Modal
      title={
        <Typography.Title level={3}>
          {t("sign_document.title")}
        </Typography.Title>
      }
      open={opened}
      onCancel={close}
      footer={null}
      style={
        isMobile
          ? {
              top: "calc(28px + var(--safe-area-inset-top, env(safe-area-inset-top, 0px)))",
            }
          : {}
      }
      styles={{}}
      className={styles.SignActModal}
    >
      <Typography.Text>{t("sign_document.description")}</Typography.Text>
      <Typography.Title level={4}>
        {t("sign_document.requirements_title")}
      </Typography.Title>
      <Typography.Title level={5}>{t("sign_document.step1")}</Typography.Title>
      <Button
        type="link"
        onClick={() =>
          window.open("https://apps.apple.com/ru/app/egov-mobile/id1476128386")
        }
      >
        {t("sign_document.egov_ios")}
      </Button>
      <br />
      <Button
        type="link"
        onClick={() =>
          window.open(
            "https://play.google.com/store/apps/details?id=kz.mobile.mgov&hl=en_GB",
          )
        }
      >
        {t("sign_document.egov_android")}
      </Button>
      <br />
      <Typography.Title level={5}>{t("sign_document.step2")}</Typography.Title>
      <Button
        type="link"
        onClick={() =>
          window.open("https://apps.apple.com/kz/app/salyq-buro/id6745878428")
        }
      >
        {t("sign_document.salyq_ios")}
      </Button>
      <br />
      <Button
        type="link"
        onClick={() =>
          window.open(
            "https://play.google.com/store/apps/details?id=kz.edo.dtt",
          )
        }
      >
        {t("sign_document.salyq_android")}
      </Button>
      <br />
      <Typography.Title level={5}>{t("sign_document.step3")}</Typography.Title>
      <Button
        type="link"
        onClick={() =>
          window.open(
            "https://youtube.com/shorts/KBWqsB1itEo?si=JEEryCxY-bgbfOa9",
          )
        }
      >
        {t("video_instruction.russian")}
      </Button>
      <br />
      <Button
        type="link"
        onClick={() =>
          window.open("https://youtube.com/shorts/FizttJsxezc?feature=share")
        }
      >
        {t("video_instruction.kazakh")}
      </Button>
      <Typography.Title level={5}>
        {t("sign_document.step4")} {actNumber}
      </Typography.Title>
    </Modal>
  );
});
